import http from './http'

export const Account = {
  login (params) {
    return http.post('accounts/login', params)
  },
  unifiedLogin (params) {
    return http.post('accounts/unified-login', params)
  },
  changePassword (params) {
    return http.post('accounts/change-password', params)
  },
  lastChangePassword (params) {
    return http.get('accounts/last-change-password', params)
  }
}

export const Auth = {
  query (params) {
    return http.get('auths', {
      params: params
    })
  }
}

export const Channel = {
  query (params) {
    return http.get('channels', {
      params: params
    })
  },
  create (params) {
    return http.post('channels', params)
  },
  delete (params) {
    return http.delete(`/channels/${params.id}`, params)
  },
  get (params) {
    return http.get(`/channels/${params.id}`, params)
  },
  update (params) {
    return http.put(`/channels/${params.id}`, params)
  }
}

export const ProductDataSale = {
  query (params) {
    return http.get('product-data-sales', {
      params: params
    })
  },
  create (params) {
    return http.post('product-data-sales', params)
  },
  delete (params) {
    return http.delete(`/product-data-sales/${params.id}`, params)
  },
  get (params) {
    return http.get(`/product-data-sales/${params.id}`, params)
  },
  update (params) {
    return http.put(`/product-data-sales/${params.id}`, params)
  }
}

export const ProductDataActive = {
  query (params) {
    return http.get('product-data-actives', {
      params: params
    })
  },
  create (params) {
    return http.post('product-data-actives', params)
  },
  delete (params) {
    return http.delete(`/product-data-actives/${params.id}`, params)
  },
  get (params) {
    return http.get(`/product-data-actives/${params.id}`, params)
  },
  update (params) {
    return http.put(`/product-data-actives/${params.id}`, params)
  }
}

export const ChannelType = {
  query (params) {
    return http.get('channel-types', {
      params: params
    })
  },
  create (params) {
    return http.post('channel-types', params)
  },
  delete (params) {
    return http.delete(`/channel-types/${params.id}`, params)
  },
  get (params) {
    return http.get(`/channel-types/${params.id}`, params)
  },
  update (params) {
    return http.put(`/channel-types/${params.id}`, params)
  }
}

export const ProductCategory = {
  query (params) {
    return http.get('product-categories', {
      params: params
    })
  },
  create (params) {
    return http.post('product-categories', params)
  },
  delete (params) {
    return http.delete(`/product-categories/${params.id}`, params)
  },
  update (params) {
    return http.put(`/product-categories/${params.id}`, params)
  },
  converProduct (params) {
    return http.put(`/product-categories/${params.id}/convert-product`, params)
  }
}

export const ProductParam = {
  query (params) {
    return http.get('product-params', { params })
  },
  create (params) {
    return http.post('product-params', params)
  },
  delete (params) {
    return http.delete(`product-params/${params.id}`)
  },
  update (params) {
    return http.put(`product-params/${params.id}`, params)
  }
}

export const Product = {
  query (params) {
    return http.get('products', {
      params: params
    })
  },
  create (params) {
    return http.post('products', params)
  },
  delete (params) {
    return http.delete(`/products/${params.id}`, params)
  },
  get (params) {
    return http.get(`/products/${params.id}`, params)
  },
  update (params) {
    return http.put(`/products/${params.id}`, params)
  },
  converSpec (params) {
    return http.put(`/products/${params.id}/convert-spec`, params)
  }
}

export const ProductSpec = {
  query (params) {
    return http.get('product-specs', {
      params: params
    })
  },
  create (params) {
    return http.post('product-specs', params)
  },
  delete (params) {
    return http.delete(`/product-specs/${params.id}`, params)
  },
  get (params) {
    return http.get(`/product-specs/${params.id}`, params)
  },
  update (params) {
    return http.put(`/product-specs/${params.id}`, params)
  },
  merge (params) {
    return http.put(`/product-specs/${params.id}/merge`, params)
  },
  setMaterial (params) {
    return http.post(`/product-specs/${params.id}/set-material`, params)
  }
}

export const Material = {
  query (params) {
    return http.get('materials', {
      params: params
    })
  },
  create (params) {
    return http.post('materials', params)
  },
  update (params) {
    return http.put(`/materials/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`materials/${params.id}`, params)
  },
  exportData (params) {
    return http.post(`materials/export`, params)
  }
}

export const MaterialCategory = {
  query (params) {
    return http.get('material-categories', {
      params: params
    })
  },
  create (params) {
    return http.post('material-categories', params)
  },
  delete (params) {
    return http.delete(`/material-categories/${params.id}`, params)
  },
  update (params) {
    return http.put(`/material-categories/${params.id}`, params)
  }
}

export const RepairMethod = {
  query (params) {
    return http.get('repair-methods', {
      params: params
    })
  },
  create (params) {
    return http.post('/repair-methods', params)
  },
  view (params) {
    return http.get(`/repair-methods/${params.id}`, params)
  },
  update (params) {
    return http.put(`/repair-methods/${params.id}`, params)
  },
  count (params) {
    return http.get(`/repair-methods/${params.id}/get-count`, params)
  }
}

export const Customer = {
  query (params) {
    return http.get('customers', {
      params: params
    })
  },
  create (params) {
    return http.post('/customers', params)
  },
  view (params) {
    return http.get(`/customers/${params.id}`, params)
  },
  update (params) {
    return http.put(`/customers/${params.id}`, params)
  }
}

export const TestResult = {
  query (params) {
    return http.get('test-results', {
      params: params
    })
  },
  get (params) {
    return http.get(`/test-results/${params.id}`, params)
  },
  create (params) {
    return http.post('test-results', params)
  },
  update (params) {
    return http.put(`/test-results/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`test-results/${params.id}`, params)
  }
}

export const TestResultCategory = {
  query (params) {
    return http.get('test-result-categories', {
      params: params
    })
  },
  create (params) {
    return http.post('test-result-categories', params)
  },
  update (params) {
    return http.put(`/test-result-categories/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`test-result-categories/${params.id}`, params)
  }
}

export const PushAgentOrderRecord = {
  query (params) {
    return http.get('push-agent-order-records', {
      params
    })
  },
  update (params) {
    return http.put(`/push-agent-order-records/${params.id}`, params)
  },
  push (params) {
    return http.post(`/push-agent-order-records/${params.id}/push`, params)
  },
  del (params) {
    return http.delete(`/push-agent-order-records/${params.id}`, params)
  }
}

export const OperationLog = {
  query (params) {
    return http.get('operation-logs', {
      params
    })
  }
}

export const OrderRecord = {
  query (params) {
    return http.get('order-records', {
      params: params
    })
  },
  create (params) {
    return http.post('order-records', params)
  },
  delete (params) {
    return http.delete(`/order-records/${params.id}`, params)
  },
  get (params) {
    return http.get(`/order-records/${params.id}`, params)
  },
  update (params) {
    return http.put(`/order-records/${params.id}`, params)
  },
  close (params) {
    return http.put(`/order-records/${params.id}/close`, params)
  },
  reduceAmount (params) {
    return http.put(`/order-records/${params.id}/reduce-amount`, params)
  },
  send (params) {
    return http.put(`/order-records/${params.id}/send`, params)
  },
  cancelSend (params) {
    return http.put(`/order-records/${params.id}/cancel-send`, params)
  },
  getLogs (params) {
    return http.get(`/order-records/${params.id}/order-log`, { params })
  },
  batchSend (params) {
    return http.post(`/order-records/batch-send`, params)
  },
  batchExport (params) {
    return http.post(`/order-records/export`, params)
  },
  kfExport (params) {
    return http.post('order-records/kf-export', params)
  },
  printExpress (params) {
    return http.put(`/order-records/${params.id}/print-express`, { params })
  },
  batchFinish (params) {
    return http.post(`/order-records/batch-finish`, params)
  },
  batchAccount (params) {
    return http.post(`/order-records/batch-account`, params)
  },
  batchImportVerify (params) {
    return http.post(`/order-records/batch-import-verify`, params)
  },
  bill (params) {
    return http.get(`/order-records/${params.id}/bill`, params)
  },
  confirmPushSap (params) {
    return http.post(`/order-records/confirm-push-sap`, params)
  },
  printMaterialInfo (params) {
    return http.get(`/order-records/${params.id}/print-material-info`, params)
  },
  setFactoryService (params) {
    return http.post(`/order-records/${params.id}/set-factory-service`, params)
  },
  uploadFile (params) {
    return http.post(`/order-records/${params.id}/upload-file`, params)
  }
}

export const PmpRecordReceiveItem = {
  export (params) {
    return http.post('pmp-record-receive-items/export', params)
  }
}

export const PmpRecord = {
  query (params) {
    return http.get('pmp-records', {
      params: params
    })
  },
  rmaIndex (params) {
    return http.get('pmp-records/rma-index', {
      params: params
    })
  },
  create (params) {
    return http.post('pmp-records', params)
  },
  import (params) {
    return http.post('pmp-records/import', params)
  },
  batchExport (params) {
    return http.post('pmp-records/export', params)
  },
  serviceExport (params) {
    return http.post('pmp-records/service-export', params)
  },
  kfExport (params) {
    return http.post('pmp-records/kf-export', params)
  },
  factoryExport (params) {
    return http.post('pmp-records/factory-export', params)
  },
  batchWaitFinish (params) {
    return http.post('pmp-records/batch-wait-finish', params)
  },
  batchFinish (params) {
    return http.post('pmp-records/batch-finish', params)
  },
  batchSend (params) {
    return http.post(`/pmp-records/batch-send`, params)
  },
  batchRepair (params) {
    return http.post(`/pmp-records/batch-repair`, params)
  },
  batchAccount (params) {
    return http.post('pmp-records/batch-account', params)
  },
  get (params) {
    return http.get(`/pmp-records/${params.id}`, params)
  },
  region (params) {
    return http.get(`/pmp-records/set-region`, { params })
  },
  materialCount (params) {
    return http.get(`/pmp-records/batch-send-material-count`, { params })
  },
  update (params) {
    return http.put(`/pmp-records/${params.id}`, params)
  },
  check (params) {
    return http.put(`/pmp-records/${params.id}/check`, params)
  },
  close (params) {
    return http.put(`/pmp-records/${params.id}/close`, params)
  },
  send (params) {
    return http.put(`/pmp-records/${params.id}/send`, params)
  },
  cancelSend (params) {
    return http.put(`/pmp-records/${params.id}/cancel-send`, params)
  },
  cancelFinish (params) {
    return http.put(`/pmp-records/${params.id}/cancel-finish`, params)
  },
  delete (params) {
    return http.delete(`/pmp-records/${params.id}`, params)
  },
  batchDelete (params) {
    return http.put(`/pmp-records/batch-delete`, params)
  },
  receive (params) {
    return http.put(`/pmp-records/${params.id}/receive`, params)
  },
  refund (params) {
    return http.put(`/pmp-records/${params.id}/refund`)
  },
  finish (params) {
    return http.put(`/pmp-records/${params.id}/finish`)
  },
  restore (params) {
    return http.put(`/pmp-records/${params.id}/restore`)
  },
  getWaitConfirmCompensation (params) {
    return http.get(`/pmp-records/wait-confirm-compensation`, { params })
  },
  postConfirmCompensation (params) {
    return http.post(`/pmp-records/confirm-compensation`, params)
  },
  repair (params) {
    return http.put(`/pmp-records/${params.id}/repair`, params)
  },
  delay (params) {
    return http.put(`/pmp-records/${params.id}/delay`)
  },
  pushCrm (params) { // 推送客服系统
    return http.put(`/pmp-records/${params.id}/push-crm`, params)
  },
  printFile (params) {
    return http.get(`/pmp-records/${params.id}/print-file`, { params })
  },
  printExpress (params) {
    return http.put(`/pmp-records/${params.id}/print-express`, { params })
  },
  orderLog (params) {
    return http.get(`/pmp-records/${params.id}/order-log`, params)
  },
  outWarehouse (params) {
    return http.get(`/pmp-records/out-warehouse`, { params })
  },
  uploadFile (params) {
    return http.post(`/pmp-records/${params.id}/upload-file`, params)
  },
  sendOrder (params) {
    return http.post(`/pmp-records/${params.id}/send-order`, params)
  },
  orderRecords (params) {
    return http.get(`/pmp-records/${params.id}/orders`, params)
  },
  dbUpdate (params) {
    return http.post(`/pmp-records/${params.id}/db-update`, params)
  },
  sendMailOutWarehouse (params) {
    return http.post(`/pmp-records/send-mail-out-warehouse`, params)
  },
  serviceFeeConfirm (params) {
    return http.post(`/pmp-records/service-fee-confirm`, params)
  },
  mergeMultiPay (params) {
    return http.post(`/pmp-records/merge-multi-pay`, params)
  },
  bill (params) {
    return http.get(`/pmp-records/${params.id}/bill`, params)
  },
  confirmPushSap (params) {
    return http.post(`/pmp-records/confirm-push-sap`, params)
  },
  printMaterialInfo (params) {
    return http.get(`/pmp-records/${params.id}/print-material-info`, params)
  },
  setFactoryService (params) {
    return http.post(`/pmp-records/${params.id}/set-factory-service`, params)
  },
  hangUp (params) {
    return http.post(`/pmp-records/${params.id}/hang-up`, params)
  },
  checkRemark (params) {
    return http.put(`/pmp-records/${params.id}/check-remark`, params)
  },
  sendSms (params) {
    return http.post(`/pmp-records/${params.id}/send-sms`, params)
  },
  pushSapTl (params) {
    return http.post(`/pmp-records/${params.id}/push-sap-tl`, params)
  },
  createAgentOrder (params) {
    return http.post(`/pmp-records/create-agent-order`, params)
  }
}

export const RmaRecord = {
  query (params) {
    return http.get('rma-records', {
      params: params
    })
  },
  update (params) {
    return http.put(`rma-records/${params.id}`, params)
  },
  pmpRecordList (params) {
    return http.get('rma-records/pmp-record-list', {
      params: params
    })
  },
  export (params) {
    return http.post(`rma-records/export`, params)
  }
}

export const OrderShipCustomerConfirm = {
  query (params) {
    return http.get('order-ship-customer-confirms', {
      params: params
    })
  },
  delete (params) {
    return http.delete(`/order-ship-customer-confirms/${params.id}`, params)
  },
}


export const Cause = {
  query (params) {
    return http.get('causes', {
      params: params
    })
  },
  create (params) {
    return http.post('causes', params)
  },
  update (params) {
    return http.put(`/causes/${params.id}`, params)
  }
}

export const Wechat = {
  info (params) {
    return http.get('/wechats/info', { params })
  },
  bind (params) {
    return http.post('/wechats/bind', params)
  },
  bindQuery (params) {
    return http.get('/wechats/bind-query', { params })
  }
}

export const Fault = {
  query (params) {
    return http.get('faults', {
      params: params
    })
  },
  create (params) {
    return http.post('faults', params)
  },
  update (params) {
    return http.put(`/faults/${params.id}`, params)
  }
}

export const AppVersion = {
  query (params) {
    return http.get('app-versions', {
      params: params
    })
  },
  create (params) {
    return http.post('app-versions', params)
  },
  update (params) {
    return http.put(`/app-versions/${params.id}`, params)
  }
}

export const RecordPushSap = {
  query (params) {
    return http.get('record-push-saps', {
      params: params
    })
  },
  update (params) {
    return http.put(`/record-push-saps/${params.id}`, params)
  },
  confirmPushSap (params) {
    return http.post(`/record-push-saps/confirm-push-sap`, params)
  },
  batchDelete (params) {
    return http.post(`/record-push-saps/batch-delete`, params)
  },
  batchSuccess (params) {
    return http.post(`/record-push-saps/batch-success`, params)
  },
  export (params) {
    return http.post(`/record-push-saps/export`, params)
  }
}

export const Notice = {
  query (params) {
    return http.get('notices', {
      params: params
    })
  },
  create (params) {
    return http.post('notices', params)
  },
  get (params) {
    return http.get(`/notices/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/notices/${params.id}`, params)
  },
  update (params) {
    return http.put(`/notices/${params.id}`, params)
  }
}

export const Faq = {
  query (params) {
    return http.get('faqs', { params: params })
  },
  create (params) {
    return http.post('faqs', params)
  },
  delete (params) {
    return http.delete(`/faqs/${params.id}`, params)
  },
  update (params) {
    return http.put(`/faqs/${params.id}`, params)
  },
  downFile (params) {
    return http.post(`/faqs/${params.id}/down-file`, params)
  }
}

export const Settings = {
  query (params) {
    return http.get('settings', {
      params: params
    })
  }
}

export const Warehouse = {
  query (params) {
    return http.get('warehouses', {
      params
    })
  },
  queryMaterials (id, params) {
    return http.get(`/warehouses/${id}/materials`, { params })
  },
  create (params) {
    return http.post('warehouses', params)
  },
  update (params) {
    return http.put('warehouses', params)
  },
  delete (params) {
    return http.delete(`warehouses/${params.id}`)
  }
}

export const WarehouseLog = {
  query (params) {
    return http.get('warehouse-logs', {
      params
    })
  },
  create (params) {
    return http.post('warehouse-logs', params)
  },
  get (params) {
    return http.get(`/warehouse-logs/${params.id}`, {
      params: params
    })
  },
  check (params) {
    return http.put(`/warehouse-logs/${params.id}/check`)
  },
  checkFail (params) {
    return http.put(`/warehouse-logs/${params.id}/check-fail`)
  },
  delete (params) {
    return http.delete(`/warehouse-logs/${params.id}`, params)
  },
  export (params) {
    const Qs = require('qs')
    return http.put(`/warehouse-logs/export?${Qs.stringify(params)}`)
  },
  exportList (params) {
    return http.get(`/warehouse-logs/export-list`, {
      params
    })
  },
  batchCheck (params) {
    return http.post(`/warehouse-logs/batch-check`, params)
  }
}

export const WarehouseTransferLog = {
  query (params) {
    return http.get('warehouse-transfer-logs', {
      params
    })
  },
  create (params) {
    return http.post('warehouse-transfer-logs', params)
  },
  get (params) {
    return http.get(`/warehouse-transfer-logs/${params.id}`, {
      params: params
    })
  },
  check (params) {
    return http.put(`/warehouse-transfer-logs/${params.id}/check`)
  },
  checkFail (params) {
    return http.put(`/warehouse-transfer-logs/${params.id}/check-fail`)
  },
  del (params) {
    return http.put(`/warehouse-transfer-logs/${params.id}/del`)
  },
  batchCheck (params) {
    return http.put(`/warehouse-transfer-logs/batch-check`, params)
  },
  exportList (params) {
    return http.get(`/warehouse-transfer-logs/export-list`, {
      params
    })
  },
  export (params) {
    const Qs = require('qs')
    return http.put(`/warehouse-transfer-logs/export?${Qs.stringify(params)}`)
  }
}

export const WarehouseAssembleLog = {
  query (params) {
    return http.get('warehouse-assemble-logs', {
      params
    })
  },
  create (params) {
    return http.post('warehouse-assemble-logs', params)
  },
  get (params) {
    return http.get(`/warehouse-assemble-logs/${params.id}`, {
      params: params
    })
  },
  check (params) {
    return http.put(`/warehouse-assemble-logs/${params.id}/check`)
  },
  checkFail (params) {
    return http.put(`/warehouse-assemble-logs/${params.id}/check-fail`)
  },
  del (params) {
    return http.put(`/warehouse-assemble-logs/${params.id}/del`)
  },
  batchCheck (params) {
    return http.put(`/warehouse-assemble-logs/batch-check`, params)
  },
  exportList (params) {
    return http.get(`/warehouse-assemble-logs/export-list`, {
      params
    })
  },
  export (params) {
    const Qs = require('qs')
    return http.put(`/warehouse-assemble-logs/export?${Qs.stringify(params)}`)
  }
}

export const WarehouseMaterials = {
  query (params) {
    return http.get('warehouse-materials', {
      params
    })
  },
  export (params) {
    const Qs = require('qs')
    return http.put(`/warehouse-materials/export?${Qs.stringify(params)}`)
  },
  update (params) {
    return http.put(`/warehouse-materials/${params.id}`, params)
  },
  updateLog (params) {
    return http.get(`/warehouse-materials/${params.id}/update-log`, params)
  }
}

export const WarehouseMaterialChecks = {
  query (params) {
    return http.get('warehouse-material-checks', {
      params
    })
  },
  add (params) {
    return http.post(`warehouse-material-checks`, params)
  }
}

export const WarehouseLogType = {
  query (params) {
    return http.get('warehouse-log-types', {
      params: params
    })
  },
  create (params) {
    return http.post('warehouse-log-types', params)
  },
  delete (params) {
    return http.delete(`/warehouse-log-types/${params.id}`, params)
  },
  get (params) {
    return http.get(`/warehouse-log-types/${params.id}`, params)
  },
  update (params) {
    return http.put(`/warehouse-log-types/${params.id}`, params)
  }
}

export const WarehouseChannel = {
  query (params) {
    return http.get('warehouse-channels', {
      params: params
    })
  },
  create (params) {
    return http.post('warehouse-channels', params)
  },
  delete (params) {
    return http.delete(`/warehouse-channels/${params.id}`, params)
  },
  get (params) {
    return http.get(`/warehouse-channels/${params.id}`, params)
  },
  update (params) {
    return http.put(`/warehouse-channels/${params.id}`, params)
  }
}

export const WarehouseTransferStation = {
  query (params) {
    return http.get('/warehouse-transfer-stations', {
      params: params
    })
  },
  create (params) {
    return http.post('/warehouse-transfer-stations', params)
  },
  check (params) {
    return http.put(`/warehouse-transfer-stations/${params.id}/check`)
  },
  createWarehouseLog (params) {
    return http.post(`/warehouse-transfer-stations/${params.id}/create-warehouse-log`, params)
  },
  sendOut (params) {
    return http.put(`/warehouse-transfer-stations/${params.id}/send-out`, params)
  },
  complete (params) {
    return http.put(`/warehouse-transfer-stations/${params.id}/complete`, params)
  }
}

export const WarehousePosition = {
  query (params) {
    return http.get(`/warehouse-positions`, { params })
  },
  post (params) {
    return http.post(`/warehouse-positions`, params)
  }
}

export const WarehouseTransferStationActionLog = {
  query (params) {
    return http.get(`/warehouse-transfer-station-action-logs`, { params })
  }
}

export const MaterialSplitItem = {
  query (params) {
    return http.get(`/material-split-items`, { params })
  },
  create (params) {
    return http.post(`/material-split-items`, params)
  },
  exportData (params) {
    return http.post(`material-split-items/export`, params)
  }
}

export const ExpressInLogs = {
  query (params) {
    return http.get('express-in-logs', {
      params
    })
  },
  create (params) {
    return http.post('express-in-logs', params)
  },
  update (params) {
    return http.put('express-in-logs', params)
  },
  pack (params) {
    return http.put(`/express-in-logs/${params.id}/open`)
  },
  transfer (params) {
    return http.post(`/express-in-logs/transfer`, params)
  },
  batchImport (params) {
    return http.post(`/express-in-logs/import`, params)
  },
  delete (params) {
    return http.delete(`/express-in-logs/${params.id}`, params)
  },
  exportData (params) {
    return http.post(`/express-in-logs/export`, params)
  }
}

export const Routes = {
  query (params) {
    return http.get('routes', {
      params
    })
  },
  create (params) {
    return http.post('routes', params)
  },
  delete (params) {
    return http.delete(`/routes/remove`, {
      data: params
    })
  }
}
export const Assignment = {
  get (params) {
    return http.get(`/user-assignments/${params.id}`, params)
  },
  addAssignment (id, params) {
    return http.post(`/user-assignments/${id}/assign`, params)
  },
  deleteAssignment (id, params) {
    return http.delete(`/user-assignments/${id}/revoke`, { data: params })
  }
}
export const AuthItemsService = {
  query (params) {
    return http.get('auth-items', {
      params
    })
  },
  create (params) {
    return http.post('auth-items', params)
  },
  update (params) {
    return http.put(`/auth-items/${params.id}`, params)
  },
  get (params, expand = false) {
    if (expand) {
      return http.get(`/auth-items/${params.id}?expand=children,avaliables`, params)
    } else {
      return http.get(`/auth-items/${params.id}`, params)
    }
  },
  delete (params) {
    return http.delete(`/auth-items/${params.id}`, { data: params })
  },
  addPermission (id, params) {
    return http.post(`/auth-items/${id}/children`, params)
  },
  deletePermission (id, params) {
    return http.delete(`/auth-items/${id}/children`, { data: params })
  }
}

export const User = {
  query (params) {
    return http.get('users', {
      params
    })
  },
  get (params) {
    return http.get(`/users/${params.id}`)
  },
  my (params) {
    return http.get(`/users/my`)
  },
  create (params) {
    return http.post('users', params)
  },
  update (params) {
    return http.put(`/users/${params.id}`, params)
  },
  exportData (params) {
    return http.post(`users/export`, params)
  }
}

export const Group = {
  query (params) {
    return http.get('groups', {
      params: params
    })
  },
  get (params) {
    return http.get(`/groups/${params.id}`, {
      params: params
    })
  },
  create (params) {
    return http.post('groups', params)
  },
  update (params) {
    return http.put(`/groups/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/groups/${params.id}`)
  }
}

export const SnImportHistory = {
  query (params) {
    return http.get('/sn-import-histories', {
      params
    })
  },
  retry (params) {
    return http.put(`/sn-import-histories/${params.id}/retry`)
  },
  delete (params) {
    return http.delete(`/sn-import-histories/${params.id}`)
  },
  deleteLog (params) {
    return http.post(`/sn-import-histories/${params.id}/delete-log`)
  },
  downUrl (params) {
    return http.put(`/sn-import-histories/${params.id}/down-url`)
  },
  change (params) {
    return http.post('/sn-import-histories/change', params)
  }
}

export const SnDeleteHistory = {
  query (params) {
    return http.get('/sn-delete-histories', {
      params
    })
  },
  create (params) {
    return http.post('/sn-delete-histories', params)
  },
  retry (params) {
    return http.post(`/sn-delete-histories/${params.id}/retry`)
  }
}

export const SnDeleteData = {
  query (params) {
    return http.get('/sn-delete-datas', {
      params
    })
  }
}

export const Sn = {
  query (params) {
    return http.get('/sns', {
      params
    })
  },
  get (params) {
    return http.get(`/sns/${params.id}`, {
      params: params
    })
  },
  queryByDl (params) {
    return http.post(`/sns/query-by-dl`, params)
  },
  batchQueryActivate (params) {
    return http.post(`/sns/batch-query-activate`, params)
  },
  batchSelectQuery (params) {
    return http.post(`/sns/batch-select-query`, params)
  },
  updateImport (params) {
    return http.post(`/sns/update-import`, params)
  }
}

export const ChangeSn = {
  query (params) {
    return http.get('/change-sns', {
      params
    })
  },
  update (params) {
    return http.put(`/change-sns/${params.id}`, params)
  },
  import (params) {
    return http.post(`/change-sns/import`, params)
  }
}

export const SnQueryByDl = {
  query (params) {
    return http.get('/sn-query-by-dls', {
      params
    })
  }
}

export const PayOrder = {
  query (params) {
    return http.get('/pay-orders', {
      params
    })
  },
  pay (params) {
    return http.put(`/pay-orders/${params.id}/pay`, params)
  },
  cancelPay (params) {
    return http.put(`/pay-orders/${params.id}/cancel-pay`, params)
  },
  close (params) {
    return http.put(`/pay-orders/${params.id}/close`)
  }
}

export const ProduceFactory = {
  query (params) {
    return http.get('/produce-factories', {
      params
    })
  },
  create (params) {
    return http.post('/produce-factories', params)
  },
  update (params) {
    return http.put(`/produce-factories/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/produce-factories/${params.id}`)
  }
}

export const FactoryUser = {
  query (params) {
    return http.get('/factory-users', params)
  },
  create (params) {
    return http.post('/factory-users', params)
  },
  view (params) {
    return http.get(`/factory-users/${params.id}`, params)
  },
  update (params) {
    return http.put(`/factory-users/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/factory-users/${params.id}`, params)
  }
}

export const WarehouseUser = {
  query (params) {
    return http.get('/warehouse-users', params)
  },
  create (params) {
    return http.post('/warehouse-users', params)
  },
  view (params) {
    return http.get(`/warehouse-users/${params.id}`, params)
  },
  update (params) {
    return http.put(`/warehouse-users/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/warehouse-users/${params.id}`, params)
  }
}

export const DeliveryWarehouse = {
  query (params) {
    return http.get('/delivery-warehouses', params)
  }
}

export const ForeignUser = {
  query (params) {
    return http.get('/foreign-users', params)
  },
  create (params) {
    return http.post('/foreign-users', params)
  },
  view (params) {
    return http.get(`/foreign-users/${params.id}`, params)
  },
  update (params) {
    return http.put(`/foreign-users/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/foreign-users/${params.id}`, params)
  }
}

export const ParamsSetting = {
  query (params) {
    return http.get('/params-settings', { params })
  },
  set3c (params) {
    return http.put('/params-settings/set3c', params)
  },
  setSnEmail (params) {
    return http.put('/params-settings/sn-email', params)
  }
}

export const FeeReason = {
  query (params) {
    return http.get('/fee-reasons', { params })
  },
  create (params) {
    return http.post('/fee-reasons', params)
  },
  update (params) {
    return http.put(`/fee-reasons/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/fee-reasons/${params.id}`)
  }
}

export const SmsLog = {
  query (params) {
    return http.get('/sms-logs', { params })
  },
  reSend (params) {
    return http.post(`/sms-logs/${params.id}/re-send`, params)
  }
}

export const SmsTemplate = {
  query (params) {
    return http.get(`/sms-templates`, { params })
  },
  delete (params) {
    return http.delete(`/sms-templates/${params.id}`, { params })
  },
  get (params) {
    return http.get(`/sms-templates/${params.id}`, { params })
  },
  update (params) {
    return http.put(`/sms-templates/${params.id}`, params)
  },
  add (params) {
    return http.post(`/sms-templates`, params)
  }
}

export const RequestSms = {
  query (params) {
    return http.get(`/request-sms`, { params })
  },
  add (params) {
    return http.post(`/request-sms`, params)
  }
}

export const PushCrmLog = {
  query (params) {
    return http.get('/push-crm-log', { params })
  }
}

export const PushBbd = {
  query (params) {
    return http.get('/push-bbds', { params })
  },
  View (params) {
    return http.get(`/push-bbds/${params.id}`)
  },
  retryPush (params) {
    return http.post(`/push-bbds/${params.id}/retry-push`)
  }
}

export const SnPostDataLog = {
  query (params) {
    return http.get('/sn-post-data-logs', { params })
  },
  addPost (params) {
    return http.post('/sn-post-data-logs/add-post', params)
  }
}

export const PushYms = {
  query (params) {
    return http.get('/push-yms', { params })
  }
}

export const Tools = {
  activateDate (params) {
    return http.get('/tools/activate-date', { params })
  },
  retreadActivateList (params) {
    return http.get('/tools/retread-activate-list', { params })
  },
  nfcFomat (params) {
    return http.post('/tools/nfc-format', params)
  },
  appBindQuery (params) {
    return http.get('/app-binds/bind-query', { params })
  },
  appBindUnBind (params) {
    return http.post('/app-binds/un-bind', params)
  },
  appBindQueryChild (params) {
    return http.get('/app-binds/bind-query-child', { params })
  },
  appUnBindChild (params) {
    return http.post('/app-binds/un-bind-child', params)
  },
  insuranceQuery (params) {
    return http.get('/insurances', { params })
  }
}

export const Region = {
  create (params) {
    return http.post('/regions', params)
  },
  update (params) {
    return http.put(`/regions/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/regions/${params.id}`, params)
  },
  query (params) {
    return http.get('/regions', { params })
  },
  view (params) {
    return http.get(`/regions/${params.id}`, params)
  },
  queryChildren (params) {
    return http.get(`/regions/${params.id}/children`, params)
  }
}

export const NfcFormatHistory = {
  query (params) {
    return http.get('/nfc-format-histories', {
      params
    })
  },
  get (params) {
    return http.get(`/nfc-format-histories/${params.id}`, {
      params: params
    })
  },
  close (params) {
    return http.put(`/nfc-format-histories/${params.id}/close`, params)
  },
  retry (params) {
    return http.put(`/nfc-format-histories/${params.id}/retry`, params)
  },
  sendSms (params) {
    return http.put(`/nfc-format-histories/${params.id}/send-sms`, params)
  },
  cardInfo (params) {
    return http.get(`/nfc-format-histories/${params.id}/card-info`, { params })
  },
}

export const FileExportHistory = {
  query (params) { // 文件导出页面
    return http.get(`/file-export-histories`, { params })
  }
}
export const PartsCost = {
  query (params) {
    return http.get('parts-costs', {
      params: params
    })
  },
  create (params) {
    return http.post('parts-costs', params)
  },
  delete (params) {
    return http.delete(`/parts-costs/${params.id}`, params)
  },
  get (params) {
    return http.get(`/parts-costs/${params.id}`, params)
  },
  update (params) {
    return http.put(`/parts-costs/${params.id}`, params)
  }
}

export const AloneCompensation = {
  query (params) {
    return http.get(`/alone-compensations`, { params })
  },
  create (params) {
    return http.post(`/alone-compensations`, params)
  },
  update (params) {
    return http.put(`/alone-compensations/${params.id}`, params)
  },
  confirm (params) {
    return http.post(`/alone-compensations/confirm`, params)
  },
  close (params) {
    return http.post(`/alone-compensations/close`, params)
  },
  reCompensate (params) {
    return http.post(`/alone-compensations/re-compensate`, params)
  },
  aliInfo (params) {
    return http.put(`/alone-compensations/${params.id}/ali-info`, params)
  },
  export (params) {
    return http.post(`/alone-compensations/export`, params)
  },
  exportSimple (params) {
    return http.post(`/alone-compensations/export-simple`, params)
  }
}

export const PmpRecordMaterial = {
  query (params) {
    return http.get(`/pmp-record-materials`, { params })
  },
  printInvoice (params) {
    return http.get(`/pmp-record-materials/print-invoice`, { params })
  },
  batchAccount (params) {
    return http.put(`/pmp-record-materials/batch-account`, params)
  },
  export (params) {
    return http.post(`/pmp-record-materials/export`, params)
  }
}

export const OrderRecordMaterial = {
  query (params) {
    return http.get(`/order-record-materials`, { params })
  },
  printInvoice (params) {
    return http.get(`/order-record-materials/print-invoice`, { params })
  },
  batchAccount (params) {
    return http.put(`/order-record-materials/batch-account`, params)
  },
  export (params) {
    return http.put(`/order-record-materials/export`, params)
  },
  batchFinish (params) {
    return http.post(`/order-record-materials/batch-finish`, params)
  }
}

export const CerpOrder = {
  query (params) {
    return http.get(`/cerp-orders`, { params })
  },
  getDetail (id) {
    return http.get(`/cerp-orders/${id}`)
  }
}

export const File = {
  downloadFile (params) {
    return http.get(`/files/download-file`, { params })
  }
}

export const AbnormalRecord = {
  query (params) {
    return http.get(`/abnormal-records`, { params })
  },
  submit (params) {
    return http.post(`/abnormal-records`, params)
  },
  update (params) {
    return http.put(`/abnormal-records/${params.id}`, params)
  },
  confirm (params) {
    return http.put(`/abnormal-records/${params.id}/confirm`, params)
  },
  problem (params) {
    return http.put(`/abnormal-records/${params.id}/problem`, params)
  },
  notAgree (params) {
    return http.put(`/abnormal-records/${params.id}/not-agree`, params)
  },
  exportData (params) {
    return http.post(`/abnormal-records/export`, params)
  },
  orderLog (params) {
    return http.get(`/abnormal-records/${params.id}/order-log`, params)
  },
  uploadFile (params) {
    return http.post(`/abnormal-records/${params.id}/upload-file`, params)
  }
}

export const Statistics = {
  pmpRecordUserQuery (params) {
    return http.post('/statistics/pmp-record-user', params)
  },
  pmpRecordSendUser (params) {
    return http.post('/statistics/pmp-record-send-user', params)
  },
  pmpRecordReceiveUser (params) {
    return http.post('/statistics/pmp-record-receive-user', params)
  },
  TestResult (params) {
    return http.post('/statistics/test-result', params)
  },
  PmpRecordCheckUser (params) {
    return http.post('/statistics/pmp-record-check-user', params)
  },
  PmpRecordCheckUserExport (params) {
    return http.post('/statistics/pmp-record-check-user-export', params)
  },
  UserMonth (params) {
    return http.post('/statistics/user-month', params)
  },
  ExpressInLog (params) {
    return http.post('/statistics/express-in-log', params)
  },
  MiReturnRecord (params) {
    return http.post('/statistics/mi-return-record', params)
  },
  PmpRecordEfficiency (params) {
    return http.post('/statistics/pmp-record-efficiency', params)
  },
  PayRate (params) {
    return http.post('/statistics/pay-rate', params)
  },
  PmpRecordEvaluate (params) {
    return http.post('/statistics/pmp-record-evaluate', params)
  },
  RepeatRepair (params) {
    return http.post('/statistics/repeat-repair', params)
  },
  RepeatRepairExport (params) {
    return http.post('/statistics/repeat-repair-export', params)
  }
}

export const ReceiveType = {
  query (params) {
    return http.get('/receive-types', { params })
  },
  create (params) {
    return http.post('/receive-types', params)
  },
  view (params) {
    return http.get(`/receive-types/${params.id}`, params)
  },
  update (params) {
    return http.put(`/receive-types/${params.id}`, params)
  },
  count (params) {
    return http.get(`/receive-types/${params.id}/get-count`, params)
  }
}

export const PmpRecordEvaluate = {
  query (params) {
    return http.get('/pmp-record-evaluates', { params })
  },
  create (params) {
    return http.post('/pmp-record-evaluates', params)
  },
  view (params) {
    return http.get(`/pmp-record-evaluates/${params.id}`, params)
  },
  export (params) {
    return http.post('/pmp-record-evaluates/export', params)
  }
}

export const AbnormalRecordCommunication = {
  create (params) {
    return http.post('/abnormal-record-communications', params)
  }
}

export const ServiceType = {
  query (params) {
    return http.get('/service-types', { params })
  },
  create (params) {
    return http.post('/service-types', params)
  },
  view (params) {
    return http.get(`/service-types/${params.id}`, params)
  },
  update (params) {
    return http.put(`/service-types/${params.id}`, params)
  },
  count (params) {
    return http.get(`/service-types/${params.id}/get-count`, params)
  }
}

export const ExpressUce = {
  query (params) {
    return http.get('/express-uces', { params })
  },
  create (params) {
    return http.post('/express-uces', params)
  },
  view (params) {
    return http.get(`/express-uces/${params.id}`, params)
  },
  update (params) {
    return http.put(`/express-uces/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/express-uces/${params.id}`, params)
  },
  import (params) {
    return http.post('/express-uces/import', params)
  }
}

export const Brand = {
  query (params) {
    return http.get('/brands', params)
  },
  create (params) {
    return http.post('/brands', params)
  },
  view (params) {
    return http.get(`/brands/${params.id}`, params)
  },
  update (params) {
    return http.put(`/brands/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/brands/${params.id}`, params)
  }
}

export const WarningUserRecord = {
  query (params) {
    return http.get('/warning-user-records', { params })
  },
  view (params) {
    return http.get(`/warning-user-records/${params.id}`, params)
  },
  update (params) {
    return http.put(`/warning-user-records/${params.id}`, params)
  }
}

export const ProductProjectCode = {
  query (params) {
    return http.get('/product-project-codes', { params })
  },
  create (params) {
    return http.post('/product-project-codes', params)
  },
  update (params) {
    return http.put(`/product-project-codes/${params.id}`, params)
  }
}

export const MaterialCodeMatch = {
  query (params) {
    return http.get('/material-code-matches', { params })
  },
  create (params) {
    return http.post('/material-code-matches', params)
  },
  view (params) {
    return http.get(`/material-code-matches/${params.id}`, params)
  },
  update (params) {
    return http.put(`/material-code-matches/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/material-code-matches/${params.id}`, params)
  }
}

export const PdaOutWarehouseHistory = {
  query (params) {
    return http.get('/pda-out-warehouse-histories', { params })
  },
  pushSap (params) {
    return http.post(`/pda-out-warehouse-histories/${params.id}/push-sap`, params)
  },
  exportSn (params) {
    return http.post(`/pda-out-warehouse-histories/${params.id}/export-sn`, params)
  },
  deleteSn (params) {
    return http.post(`/pda-out-warehouse-histories/${params.id}/delete-sn`, params)
  },
  saveSn (params) {
    return http.post(`/pda-out-warehouse-histories/${params.id}/save-sn`, params)
  }
}

export const Bill = {
  query (params) {
    return http.get('/bills', { params })
  },
  create (params) {
    return http.post('/bills', params)
  },
  view (params) {
    return http.get(`/bills/${params.id}`, params)
  },
  update (params) {
    return http.put(`/bills/${params.id}`, params)
  }
}

export const MiReturnRecord = {
  query (params) {
    return http.get('/mi-return-records', { params })
  },
  update (params) {
    return http.put(`/mi-return-records/${params.id}`, params)
  },
  exportData (params) {
    return http.post(`/mi-return-records/export`, params)
  },
  delete (params) {
    return http.post(`/mi-return-records/delete`, params)
  },
  batchIn (params) {
    return http.post(`/mi-return-records/batch-in`, params)
  }
}

export const GiveType = {
  query (params) {
    return http.get('/give-types', params)
  },
  create (params) {
    return http.post('/give-types', params)
  },
  view (params) {
    return http.get(`/give-types/${params.id}`, params)
  },
  update (params) {
    return http.put(`/give-types/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/give-types/${params.id}`, params)
  }
}

export const AgentProduct = {
  query (params) {
    return http.get('/agent-products', { params })
  },
  update (params) {
    return http.put(`/agent-products/${params.id}`, params)
  },
  batchUpdate (params) {
    return http.put(`/agent-products/batch-update`, params)
  }
}

export const PmpRecordSmsSend = {
  query (params) {
    return http.get('/pmp-record-sms-sends', { params })
  }
}

export const PmpRecordCustomerService = {
  query (params) {
    return http.get('/pmp-record-customer-services', { params })
  }
}

export const PmpRecordRemark = {
  create (params) {
    return http.post('/pmp-record-remarks', params)
  }
}

export const StatisticsRecord = {
  query (params) {
    return http.get('/statistics-records', { params })
  },
  update (params) {
    return http.put(`/statistics-records/${params.id}`, params)
  },
  create (params) {
    return http.post('/statistics-records', params)
  },
  view (params) {
    return http.get(`/statistics-records/${params.id}`, params)
  }
}

export const StatisticsRecordList = {
  query (params) {
    return http.get('/statistics-record-lists', { params })
  },
  update (params) {
    return http.put(`/statistics-record-lists/${params.id}`, params)
  },
  create (params) {
    return http.post('/statistics-record-lists', params)
  },
  view (params) {
    return http.get(`/statistics-record-lists/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/statistics-record-lists/${params.id}`, params)
  }
}

export const ProductLine = {
  query (params) {
    return http.get('/product-lines', { params })
  },
  create (params) {
    return http.post('/product-lines', params)
  },
  view (params) {
    return http.get(`/product-lines/${params.id}`, params)
  },
  update (params) {
    return http.put(`/product-lines/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/product-lines/${params.id}`, params)
  },
  bindProduct (params) {
    return http.post(`/product-lines/${params.id}/bind-product`, params)
  }
}

export const BondAreaRetreadRecord = {
  query (params) {
    return http.get('/bonded-area-retread-records', { params })
  },
  view (params) {
    return http.get(`/bonded-area-retread-records/${params.id}`, params)
  },
  update (params) {
    return http.put(`/bonded-area-retread-records/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/bonded-area-retread-records/${params.id}`, params)
  },
  getLog (params) {
    return http.get(`/bonded-area-retread-records/${params.id}/log`, params)
  },
  batchExport (params) {
    return http.get('/bonded-area-retread-records/export', { params })
  }
}

export const MiReturnRecordList = {
  query (params) {
    return http.get('/mi-return-record-lists', { params })
  },
  create (params) {
    return http.post('/mi-return-record-lists', params)
  },
  view (params) {
    return http.get(`/mi-return-record-lists/${params.id}`, params)
  },
  update (params) {
    return http.put(`/mi-return-record-lists/${params.id}`, params)
  },
  forceuUdate (params) {
    return http.post(`/mi-return-record-lists/${params.id}/force-update`, params)
  },
  delete (params) {
    return http.delete(`/mi-return-record-lists/${params.id}`, params)
  },
  confirm (params) {
    return http.post(`/mi-return-record-lists/${params.id}/confirm`, params)
  },
  transferReturn (params) {
    return http.post(`/mi-return-record-lists/${params.id}/transfer-return`, params)
  },
  deleteSap (params) {
    return http.post(`/mi-return-record-lists/${params.id}/delete-sap`, params)
  },
}

export const TradesSn = {
  query (params) {
    return http.get('/trades-sns', { params })
  }
}

export const EqualChangeProduct = {
  query (params) {
    return http.get('/equal-change-products', { params })
  },
  create (params) {
    return http.post('/equal-change-products', params)
  },
  view (params) {
    return http.get(`/equal-change-products/${params.id}`, params)
  },
  update (params) {
    return http.put(`/equal-change-products/${params.id}`, params)
  }
}

export const ParamSetting = {
  query (params) {
    return http.get('/param-settings', { params })
  },
  create (params) {
    return http.post('/param-settings', params)
  },
  view (params) {
    return http.get(`/param-settings/${params.id}`, params)
  },
  update (params) {
    return http.put(`/param-settings/${params.id}`, params)
  },
  delete (params) {
    return http.delete(`/param-settings/${params.id}`, params)
  }
}
